<template>
  <div>
    <!-- Main Modal -->
    <a-modal
      v-model:visible="isShowModal"
      width="100%"
      wrap-class-name="full-modal"
      :footer="null"
      :header="null"
    >
      <div class="d-flex align-items-center gap-3">
        <i class="fa-solid fa-clock-rotate-left text-light cursor" />
        <i
          class="fa-solid cursor"
          :class="
            isSoundMuted
              ? 'fa-volume-high text-light'
              : 'fa-volume-xmark text-danger'
          "
          @click="pauseSound()"
        />
      </div>
      <div class="modal-body">
        <div>
          <template v-if="!['', null, undefined].includes(remoteIdentity)">
            <h4 class="text-center text-light mb-3">
              {{ remoteIdentity?.displayName ?? "" }}
            </h4>
            <h4 class="text-center text-light mb-3">
              {{ remoteIdentity?.uri?.raw?.user ?? "" }}
            </h4>
          </template>
          <h5 class="text-center text-light mx-1">
            {{
              isCallDialing
                ? "Calling..."
                : isAlreadyOnCall
                ? "In call"
                : currentMessage
            }}
          </h5>
          <h5 class="text-center text-light mx-1">{{ sessionTime ?? "" }}</h5>
          <!-- keypad -->
          <div class="theme-keypad" v-if="isShowKeyPad">
            <div class="p-3 mb-3">
              <div class="text-center position-relative">
                <input
                  type="text"
                  class="border-0 fs-4 text-center outline-0"
                  v-model="mobile_number"
                />
                <i
                  class="fa-solid fa-delete-left fs-4 text-light number-back-arrow pointer"
                  v-if="mobile_number.length !== 0"
                  @click="handleRemoveValue()"
                />
              </div>
              <div class="white-keypad">
                <simpleKeyBoard
                  :input="mobile_number"
                  @onChange="handleChange"
                  @onKeyPress="handleKeyPress"
                />
              </div>
            </div>
            <div class="call-btn" @click="transfer(mobile_number)">
              <i class="fa-solid fa-phone" />
            </div>
            <div
              class="common-avatar back-btn p-1 mx-auto mt-3"
              @click="getBackToCall()"
            >
              <i class="fa-solid fa-arrow-left" />
            </div>
          </div>
          <div v-else>
            <div class="text-center text-light">
              <div class="user-icon">
                <vue-feather type="user" size="5rem" class="m-0" />
              </div>
              <h4>
                {{
                  ["", null, undefined].includes(remoteIdentity) &&
                  mobile_number
                    ? mobile_number.replace(
                        /(\d{3})(\d{3})(\d{4})/,
                        "($1) $2-$3"
                      )
                    : ""
                }}
              </h4>
              <p>California</p>
              <span class="calling-badge text-light">
                Calling from
                {{
                  domain?.main_cid.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    "($1) $2-$3"
                  )
                }}
              </span>
            </div>
            <ul class="dial-widget mt-4">
              <template v-if="!isCallDialing">
                <li @click="handleDTMF()">
                  <img alt="dial_pad" src="@/assets/dial-pad.png" />
                </li>
                <li @click="onCallMute">
                  <i
                    :class="
                      isMuted
                        ? 'fa-solid fa-microphone-slash'
                        : 'fa-solid fa-microphone'
                    "
                  />
                </li>
                <li class="position-relative" @click="callOnHold()">
                  <img
                    alt="pause_call"
                    src="@/assets/pause-call.png"
                    class="mw-20"
                  />
                </li>
                <li class="position-relative" @click="callOnTransfer()">
                  <img
                    alt="outgoing_call"
                    src="@/assets/outgoing-call.png"
                    class=""
                  />
                </li>
              </template>
              <li @click="hangup()">
                <div class="common-avatar avatar-end-call">
                  <!-- @click="callOnUnHold" -->
                  <i
                    class="fa-solid fa-phone"
                    :class="isCallDialing ? 'text-danger' : ''"
                  />
                </div>
              </li>
            </ul>

            <!-- start call -->
            <div class="d-none">
              <p class="text-light text-center">Start a Call.</p>
              <div class="bg-lightblack">
                <div class="video-call">
                  <div class="text-center text-light">
                    <h3>You have active calls.</h3>
                    <p>Closing the phone will terminate all calls.</p>
                    <p>Are you sure?</p>
                    <div
                      class="d-flex align-items-center justify-content-center gap-2"
                    >
                      <button class="btn cancel-btn">Cancel</button>
                      <button class="btn close-btn">
                        <i class="fa-solid fa-phone text-light" />
                        <span>Close Phone</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Call List -->
          <div class="min-w-350" v-if="isCallOnHold">
            <div
              class="bg-blue d-flex align-items-center justify-content-between"
            >
              <h6 class="text-light mb-0">HOLD</h6>
              <h6 class="text-light mb-0">{{ formattedElapsedTime }}</h6>
            </div>
            <div
              class="bg-number-call d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="common-avatar avatar-user">
                  <i class="fa-solid fa-user" />
                </div>
                <div>
                  <div class="text-light">
                    {{
                      ["", null, undefined].includes(remoteIdentity) &&
                      mobile_number
                        ? mobile_number.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "($1) $2-$3"
                          )
                        : ""
                    }}
                  </div>
                  <div class="text-light">{{ dialFrom }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <div class="common-avatar avatar-call" @click="callOnUnHold">
                  <i class="fa-solid fa-phone" />
                </div>
                <div
                  class="common-avatar avatar-end-call"
                  @click="callOnUnHold"
                >
                  <i class="fa-solid fa-phone" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- Incoming Call -->
    <a-modal
      v-model:visible="incomingCallOpen"
      :footer="null"
      centered
      :mask-closable="maskClosable"
      class="modal-bg-transparent"
    >
      <h4 class="text-center text-light mb-2">
        {{ remoteIdentity?._displayName ?? "-" }}
      </h4>
      <h4 class="text-center text-light mb-2">
        {{ remoteIdentity?.uri?.raw?.user ?? "-" }}
      </h4>
      <h2 class="fw-bold mb-5 text-light text-center">Incoming Call</h2>
      <div class="d-flex align-items-center justify-content-center gap-5">
        <div class="incoming-call incoming-end-call" @click="rejectCall()">
          <i class="fa-solid fa-phone" />
        </div>
        <div class="incoming-call incoming-call-receive" @click="acceptCall()">
          <i class="fa-solid fa-phone-flip" />
        </div>
      </div>
    </a-modal>
    <!-- Main Call Button -->
    <div
      class="action"
      :class="
        isUserRegisted
          ? isAlreadyOnCall
            ? 'success success-animation'
            : 'success'
          : 'fail'
      "
      ref="action"
      v-if="!isShowModal"
    >
      <span>
        <i class="fa-solid fa-phone" @click="actionToggle('add')" />
      </span>
      <ul>
        <div class="setting-icon" @click="showLoginForm()">
          <i
            :class="
              isShowLoginForm ? 'fa-solid fa-arrow-left' : 'fa-solid fa-gear'
            "
          />
        </div>
        <div class="close-icon" @click="actionToggle('remove')">
          <i class="fa-solid fa-xmark" />
        </div>
        <div v-if="isShowLoginForm">
          <div style="width: 304px">
            <div
              class="pt-30 px-3 pb-3 text-center"
              :class="isShowLoginForm ? 'min-h-357' : ''"
            >
              <h6>Settings</h6>
              <div
                class="call-btn position-relative edit-icon"
                :class="isUserRegisted ? 'text-light' : 'login p-1'"
              >
                <template v-if="!isUserRegisted">
                  <a-select
                    ref="select"
                    v-model:value="selectedExtion"
                    class="w-100"
                    @change="handleExtensionChange"
                    show-search
                    :options="extensionOptions"
                    :filter-option="
                      (input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  >
                  </a-select>
                  <vue-feather type="edit-2" class="me-0" />
                </template>
                <span v-else>
                  <h5>{{ selectedExtion }}</h5>
                </span>
              </div>
            </div>
            <div
              :class="isUserRegisted ? 'logout text-light' : 'call-btn'"
              @click="handleLogin()"
            >
              {{ isUserRegisted ? "Logout" : "Login" }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="pt-30 px-3 pb-3">
            <div class="text-center position-relative">
              <input
                autofocus
                type="text"
                class="border-0 fs-4 text-center outline-0"
                v-model="mobile_number"
                ref="mobileInput"
              />
              <i
                class="fa-solid fa-delete-left fs-4 number-back-arrow"
                v-if="mobile_number.length !== 0"
                @click="handleRemoveValue()"
              />
            </div>
            <div class="white-keypad">
              <simpleKeyBoard :input="mobile_number" @onChange="handleChange" />
            </div>
          </div>
          <div class="call-btn" @click="callDial('call')">
            <i class="fa-solid fa-phone" />
          </div>
        </div>
      </ul>
    </div>
  </div>
  <div class="stream">
    <audio id="remoteAudio" ref="remoteAudio" autoplay />
    <audio id="localAudio" />
    <audio
      id="myAudio"
      ref="myAudio"
      :src="require('@/assets/sound/ring.mp3')"
    />
    <audio
      id="callRinging"
      ref="callRinging"
      :src="require('@/assets/sound/ringing.mp3')"
    />
    <audio
      id="call_dial"
      ref="call_dial"
      :src="require('@/assets/sound/call_dial.mp3')"
    />
  </div>
</template>

<script>
import simpleKeyBoard from "@/components/simpleKeyboard.vue";
import { authComputed } from "@/store/helpers";
import { message } from "ant-design-vue";

export default {
  data() {
    return {
      socketConnectionURL: {
        wsServers: ["wss://webpush.cloudext.co:9936/ws"],
      },
      socketConnection: "",
      login_form: {
        uri: "",
        user: "",
        password: "",
      },
      selectedExtension: "",
      isShowModal: false,
      mobile_number: "",
      count: 0,
      userAgent: null,
      simple: null,
      session: null,
      pc: null,
      dialFrom: null,
      used: "",
      config: JSON.parse(sessionStorage.getItem("credential")) ?? {},
      media: {
        sessionDescriptionHandlerOptions: {
          constraints: { audio: true, video: false },
        },
      },
      currentMessage: "",
      callTimer: null,
      elapsedTime: 0,
      isAlreadyOnCall: false,
      isCallDialing: false,
      isShowKeyPad: false,
      isSoundMuted: true,
      isMuted: false,
      isCallOnHold: false,
      isUserRegisted: sessionStorage.credential ? true : false,
      isCallTransfered: false,
      isHandleDtfm: false,
      incomingCallOpen: false,
      maskClosable: false,
      isShowLoginForm: false,
      selectedExtion: "",
      extensionOptions: [],
      remoteIdentity: {},
      sessionTime: null,
      intervalId: null,
    };
  },
  computed: {
    ...authComputed,
    formattedElapsedTime() {
      // const hours = Math.floor(this.elapsedTime / 3600);
      const minutes = Math.floor((this.elapsedTime % 3600) / 60);
      const seconds = this.elapsedTime % 60;
      return `${minutes}:${seconds}`;
    },
  },
  watch: {
    mobile_number() {
      this.$refs.call_dial.play();
    },
  },
  components: { simpleKeyBoard },
  mounted() {
    if (sessionStorage.credential) {
      this.isUserRegisted = true;
      const credential = JSON.parse(sessionStorage.getItem("credential"));
      this.userRegister(credential, "", "", "config_data");
    }
    this.used = this.config?.uri;
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.$refs?.action?.classList.remove("active");
      }
      if (event.key === "Enter") {
        this.call(this.mobile_number);
      }
    });
    // setTimeout(() => {
    //   this.actionToggle("add");
    //   setTimeout(() => {
    //     this.actionToggle("remove");
    //   }, 1000);
    // }, 1000);
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    this.timerstop();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    // WEBRTC METHODs
    connectWebSocket() {
      try {
        this.socketConnection = new WebSocket(
          this.socketConnectionURL.wsServers[0]
        );
      } catch (error) {
        message.warn("Websocket is not connected !");
        return;
      }
      setTimeout(() => {
        if (this.socketConnection && this.socketConnection.readyState == 0) {
          message.warn("Websocket is not connecting !");
          return false;
        } else if (
          this.socketConnection &&
          this.socketConnection.readyState == 1
        ) {
          message.success("Websocket is connected !");
          this.dologin();
          return true;
        } else if (
          this.socketConnection &&
          this.socketConnection.readyState == 3
        ) {
          message.warn("Websocket is closed !");
          return false;
        }
      }, 1000);
    },
    dologin() {
      this.userRegister(
        this.login_form.uri,
        this.login_form.user,
        this.login_form.password
      );
    },
    userRegister(domain, username, password, data) {
      if (data !== "config_data") {
        if (Object.keys(this.config).length == 0) {
          // used = this.config.uri;
          // this.config.contactName = this.config.authorizationUser;
          // config.hackIpInContact=true;
          // config.usePreloadedRoute=true;
          // config.hackWssInTransport= true;
          // config.hackViaTcp= true;
          this.config["domain"] = domain;
          // this.config.rtcpMuxPolicy = "negotiate";
          this.config.autostart = true;
          this.config.register = true;
          this.config.registrarServer = domain;
          this.config.RegisterContext = { expires: 3600 };
          this.config.authorizationUser = username;
          this.config.password = password;
          this.config.uri =
            this.config.authorizationUser + "@" + this.config.domain;
          this.config.wsServers = this.socketConnectionURL;
          this.config.transportOptions = this.socketConnectionURL;
          this.config.displayName =
            this.selectedExtension?.outbound_caller_id_name ??
            this.selectedExtension?.outbound_caller_id_number ??
            this.selectedExtension?.extension;
          this.config.traceSip = true;
        }
      }
      try {
        this.userAgent = new window.SIP.UA(this.config);
        this.userAgent.start();
        this.userAgent.on("registered", () => {
          sessionStorage.setItem("isRegistered", true);
          sessionStorage.setItem("credential", JSON.stringify(this.config));
          this.isUserRegisted = true;
          this.incomingCall();
          this.onsuccessfullRegistrarion();
        });

        this.userAgent.on("registrationFailed", () => {
          sessionStorage.removeItem("credential");
          sessionStorage.setItem("isRegistered", false);
          this.userUnregister();
          return;
        });
      } catch (error) {
        this.userUnregister();
        sessionStorage.removeItem("credential");
        sessionStorage.setItem("isRegistered", false);
      }
    },
    userUnregister() {
      if (this.config) {
        this.resetData();
        this.config = {};
        sessionStorage.removeItem("credential");
        sessionStorage.setItem("isRegistered", false);
        this.$refs?.action?.classList.remove("active");
        sessionStorage.removeItem("csRegistered");
        this.isUserRegisted = false;
      }
      if (this.userAgent) {
        this.userAgent.unregister();
      }
    },
    incomingCall() {
      this.userAgent.on("invite", (sessiondata) => {
        this.session = sessiondata;
        this.remoteIdentity = this.session.remoteIdentity;
        this.dialFrom = this.session.remoteIdentity.uri.displayName;
        if (!this.isAlreadyOnCall) {
          this.incomingCallOpen = true;
          this.$refs.myAudio?.play();
          this.isAlreadyOnCall = true;
        }
        this.session.on("trackAdded", () => {
          this.pc = this.session.sessionDescriptionHandler.peerConnection;
          var remoteStream = new MediaStream();
          this.pc.getReceivers().forEach((receiver) => {
            remoteStream.addTrack(receiver.track);
          });
          this.$refs.remoteAudio.srcObject = remoteStream;
        });
        this.onEventListeners();
      });
    },
    calculateCallDuration(startTime) {
      // Calculate call duration based on start time
      const currentTime = new Date();
      const duration = currentTime - startTime;
      const seconds = Math.floor((duration / 1000) % 60);
      const minutes = Math.floor((duration / (1000 * 60)) % 60);
      const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      // Format each component with leading zeros
      const formattedHours = hours.toString().padStart(2, "0");
      const formattedMinutes = minutes.toString().padStart(2, "0");
      const formattedSeconds = seconds.toString().padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },
    onsuccessfullRegistrarion() {
      this.actionToggle("remove");
    },
    callDial(call_dial_for) {
      if (this.mobile_number.length !== 0) {
        if (this.session && this.session.hasAnswer) {
          message.warn("Call is already connected !");
          return;
        }
        if (call_dial_for == "call") {
          this.call(this.mobile_number);
        }
      }
    },
    timerstart() {
      if (!this.callTimer) {
        this.callTimer = setInterval(() => {
          this.elapsedTime += 1;
        }, 1000); // Update elapsed time every second
      }
    },
    timerstop() {
      if (this.callTimer) {
        clearInterval(this.callTimer);
        this.callTimer = null;
      }
    },
    call(number) {
      try {
        if (number) {
          this.isShowModal = true;
          this.isCallDialing = true;
          this.$refs.callRinging?.play();
          number = number + "@" + this.config.domain;
          this.session = this.userAgent.invite(number, this.media);
          this.onEventListeners();
          this.session.on("trackAdded", () => {
            this.pc = this.session.sessionDescriptionHandler.peerConnection;
            // Gets remote tracks
            var remoteStream = new MediaStream();
            this.pc.getReceivers().forEach(function (receiver) {
              remoteStream.addTrack(receiver.track);
            });
            this.$refs.remoteAudio.srcObject = remoteStream;
          });
        }
      } catch (error) {
        this.$refs.callRinging?.pause();
        this.isCallDialing = false;
        this.isShowModal = false;
        message.error("Invalid Number");
      }
    },
    acceptCall() {
      this.session.accept();
      this.remoteIdentity = this.session.remoteIdentity;
      this.sessionTime = "";
      setTimeout(() => {
        this.intervalId = setInterval(() => {
          if (!["", null, undefined].includes(this.session?.startTime)) {
            this.sessionTime = this.calculateCallDuration(
              this.session.startTime
            );
          } else {
            this.stopCallDurationUpdate();
          }
        }, 1000);
      }, 2000);
      this.$refs.myAudio.pause();
      this.incomingCallOpen = false;
    },
    rejectCall() {
      this.session?.reject();
      this.$refs.myAudio.pause();
      this.stopCallDurationUpdate();
      this.incomingCallOpen = false;
    },
    stopCallDurationUpdate() {
      clearInterval(this.intervalId);
    },
    hangup() {
      if (this.session) {
        if (!this.session.hasAnswer) {
          this.session.cancel();
        } else {
          this.session.bye();
        }
      }
      this.stopCallDurationUpdate();
      this.resetData();
    },
    mute() {
      if (this.pc) {
        this.pc.getLocalStreams().forEach((stream) => {
          stream.getAudioTracks().forEach((track) => {
            this.isMuted = true;
            track.enabled = false;
          });
        });
      }
    },
    unmute() {
      if (this.pc) {
        this.pc.getLocalStreams().forEach((stream) => {
          stream.getAudioTracks().forEach((track) => {
            this.isMuted = false;
            track.enabled = true;
          });
        });
      }
    },
    transfer(number) {
      if (this.session) {
        this.session.refer(number, this.media);
      }
    },
    dtmf(tone) {
      if (this.session) {
        this.session.dtmf(tone);
      }
    },
    onEventListeners() {
      if (this.session) {
        this.session.on("accepted", () => {
          this.remoteIdentity = this.session.remoteIdentity;
          this.isCallDialing = false;
          this.sessionTime = "";
          setTimeout(() => {
            if (this.session && this.session.hasAnswer) {
              this.remoteIdentity = this.session.remoteIdentity;
              message.success("Connected !!");
              setTimeout(() => {
                this.intervalId = setInterval(() => {
                  if (
                    !["", null, undefined].includes(this.session?.startTime)
                  ) {
                    this.sessionTime = this.calculateCallDuration(
                      this.session.startTime
                    );
                  } else {
                    this.stopCallDurationUpdate();
                  }
                }, 1000);
              }, 2000);
              this.$refs.callRinging?.pause();
              this.$refs.myAudio?.pause();
              this.isShowModal = true;
              this.mobile_number = "";
              this.timerstart();
            }
          }, 1000);
        });
        this.session.on("terminated", (msg, cause) => {
          this.resetData();
          this.incomingCallOpen = false;
          this.isAlreadyOnCall = false;
          this.$refs.callRinging.pause();
          if (msg && msg.reasonPhrase && msg.reasonPhrase !== "") {
            message.info(message.reasonPhrase || "Call Ended !!");
          } else {
            if (cause == "WebRTC Error") {
              message.info("Microphone could not found !");
            } else {
              if (cause != "") {
                this.currentMessage = cause;
              }
            }
          }
          this.timerstop();
          this.$refs.myAudio.pause();
          this.mobile_number = "";
          this.isShowModal = false;
          this.session = null;
          this.pc = null;
        });
        // this.session.on("dtmf", () => {
        //   message.info("DTMF Send");
        // });
      }
    },
    // CUSTOM METHODs
    handleChange(data) {
      this.mobile_number = data;
    },
    handleKeyPress(data) {
      if (this.isHandleDtfm) {
        this.dtmf(data);
      }
    },
    actionToggle(status) {
      if (this.isAlreadyOnCall) {
        this.isShowModal = true;
      } else {
        if (!this.isUserRegisted) {
          this.isShowLoginForm = true;
          this.getExtensionList();
        } else {
          const data = JSON.parse(sessionStorage.getItem("credential"));
          this.selectedExtion = data?.authorizationUser;
        }
        if (status === "add") {
          this.$refs?.action?.classList.add("active");
          setTimeout(() => {
            const inputElement = this.$refs.mobileInput;
            if (inputElement) {
              inputElement.focus();
            }
          }, 300);
        } else {
          this.$refs?.action?.classList.remove("active");
          this.mobile_number = "";
        }
      }
    },
    onCallMute() {
      this.isMuted = !this.isMuted;
      if (this.isMuted == false) {
        this.unmute();
      } else {
        this.mute();
      }
    },
    callOnHold() {
      this.isCallOnHold = true;
      if (this.session) {
        this.session.hold(this.userAgent);
      }
    },
    callOnUnHold() {
      this.isCallOnHold = false;
      if (this.session) {
        this.session.unhold();
      }
    },
    callOnTransfer() {
      this.isShowKeyPad = true;
      this.isCallTransfered = true;
    },
    handleDTMF() {
      this.isShowKeyPad = true;
      this.isHandleDtfm = true;
    },
    getBackToCall() {
      this.isShowKeyPad = false;
      this.session.unhold();
    },
    pauseSound() {
      if (this.$refs.remoteAudio.paused) {
        this.isSoundMuted = true;
        this.$refs.remoteAudio.play();
      } else {
        this.isSoundMuted = false;
        this.$refs.remoteAudio.pause();
      }
    },
    handleRemoveValue() {
      if (this.mobile_number.length !== 0) {
        this.mobile_number = this.mobile_number.slice(0, -1);
      }
    },
    showLoginForm() {
      this.isShowLoginForm = !this.isShowLoginForm;
    },
    handleLogin() {
      if (this.isUserRegisted) {
        this.userUnregister();
      } else {
        this.dologin();
      }
    },
    getExtensionList() {
      const data = JSON.parse(sessionStorage.getItem("extensions"));
      let dataArray = [];
      data.map((item) => {
        if (["", undefined, null].includes(item.mac)) {
          dataArray.push(item);
        }
      });
      this.extensionOptions = dataArray;
    },
    handleExtensionChange() {
      const findExtension = this.extensionOptions.find(
        (item) => item.value == this.selectedExtion
      );
      if (findExtension) {
        this.selectedExtension = findExtension;
        this.login_form = {
          uri: this.domain.domain_name + ":9360",
          user: findExtension.value,
          password: findExtension.password,
        };
        this.dologin();
        this.isShowLoginForm = false;
      }
    },
    resetData() {
      this.isShowModal = false;
      this.currentMessage = "";
      this.remoteIdentity = {};
      this.sessionTime = null;
      this.callTimer = null;
      this.elapsedTime = 0;
      this.isCallDialing = false;
      this.isShowKeyPad = false;
      this.isSoundMuted = true;
      this.isMuted = false;
      this.isCallOnHold = false;
      this.isCallTransfered = false;
      this.isHandleDtfm = false;
      this.incomingCallOpen = false;
      this.maskClosable = false;
      this.isShowLoginForm = false;
    },
    handleBeforeUnload(event) {
      if (
        !["", null, undefined].includes(this.config) &&
        Object.keys(this.config).length !== 0
      ) {
        this.userUnregister();
        event.preventDefault();
        event.returnValue = "";
      }
    },
  },
};
</script>

<style>
.full-modal .ant-modal {
  max-width: 100%;
  top: 0;
  padding-bottom: 0;
  margin: 0;
}
.full-modal .ant-modal-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh);
  background: linear-gradient(to bottom right, #003755 0%, #286a92 100%);
}
.full-modal .ant-modal-close-x {
  color: #fff;
}
/* dial keypad */
.white-keypad .hg-theme-default {
  background-color: transparent;
}
.white-keypad .hg-theme-default .hg-button {
  box-shadow: none;
  border-bottom: 0px;
}
.white-keypad .hg-theme-default .hg-button span {
  font-size: 20px;
}
/* theme dial keypad */
.theme-keypad .mb-3 {
  background-color: #052a41;
}
.theme-keypad .line {
  padding: 16px;
  max-width: 250px;
  margin: auto;
  background-color: #052a41;
}
.theme-keypad .hg-theme-default {
  background-color: #052f48;
  border-radius: 0px;
  padding: 0px;
}
.theme-keypad .hg-theme-default .hg-button {
  box-shadow: none;
  background-color: #052a41;
}
.theme-keypad .hg-theme-default .hg-button span {
  color: #fff;
  font-size: 20px;
}
.theme-keypad input {
  outline: none;
  color: #fff;
  padding: 0px 6px;
  background-color: #052a41;
}
.theme-keypad .hg-theme-default .hg-row:not(:last-child),
.theme-keypad .hg-theme-default .hg-row .hg-button:not(:last-child) {
  background-color: #052a41;
  margin-bottom: 0px;
  padding-bottom: 5px;
  margin-right: 0px;
  padding-right: 5px;
}
.number-back-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
}
.min-w-350 {
  min-width: 350px;
  position: absolute;
  bottom: 20px;
}
.bg-blue {
  padding: 6px 10px;
  background-color: #1a9bf8;
}
.common-avatar {
  width: 50px;
  height: 50px;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  cursor: pointer;
}
.avatar-user {
  color: #0d3850;
  background-color: #00bdff;
}
.bg-number-call {
  background-color: #052a41;
  padding: 10px;
}
.avatar-call {
  color: #fff;
  background-color: #40c689;
}
.avatar-end-call {
  color: #fff;
  background-color: #f43631;
  transform: rotate(136deg);
}
.back-btn {
  color: #fff;
  background-color: #0c405a;
}
.modal-bg-transparent .ant-modal-content {
  background-color: transparent;
  box-shadow: none;
}
.modal-bg-transparent .ant-modal-close {
  display: none;
}
</style>
<style scoped>
/* float btn */
.action {
  position: fixed;
  bottom: 120px;
  right: 35px;
  width: 60px;
  height: 60px;
  background: #00bdff;
  border-radius: 50%;
  cursor: pointer;
}
.action span i {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  border-radius: 50%;
  border: 3px solid #ffffff;
  transition: transform 0.7s ease-in-out, box-shadow 0.7s ease-in-out;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.3);
}
.action span i:hover {
  transform: rotate(360deg); /* Rotate and move up by 5 pixels */
}
.action.success {
  border: 4px solid #40c689;
}
.success-animation {
  animation: play 1.5s ease infinite;
  backface-visibility: hidden;
  background-color: #40c689; /* green color */
}
.success-animation:before {
  position: absolute;
  content: " ";
  z-index: -1;
  top: -25px;
  left: -25px;
  background-color: #40c689;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  animation-fill-mode: both;
  opacity: 0.6;
  animation: incomingPulse 1.5s ease-out;
  animation-iteration-count: infinite;
}
.action.fail {
  border: 4px solid #000000;
}
.action ul {
  position: absolute;
  bottom: 55px;
  right: 0px;
  padding: 0;
  margin: 0;
  background: #fff;
  min-width: 250px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}
.action.active ul {
  bottom: 0px;
  right: 0px;
  opacity: 1;
  visibility: visible;
  transition: 0.3s;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.action ul li {
  list-style: none;
  text-decoration: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0;
}
.action ul li:hover {
  font-weight: 600;
}
.action ul li:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.action ul li img {
  margin-right: 15px;
  opacity: 0.2;
  transform: scale(0.7);
}
.action ul li:hover img {
  opacity: 0.8;
  transform: scale(1);
}
.call-btn {
  text-align: center;
  width: 100%;
  padding: 10px;
  background-color: #40c689;
}
.call-btn .login {
  background-color: #ffffff;
  border: 1px solid black;
  color: #000;
}
.logout {
  text-align: center;
  width: 100%;
  padding: 10px;
  background-color: #ff3939 !important;
}
.call-btn i {
  color: #fff;
  font-size: 22px;
}

.setting-icon i {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 24px;
}
.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  padding: 0px 6px;
  border-radius: 50%;
  background-color: #2d2d2d;
}
.close-btn i {
  font-size: 10px;
}

/* dialpad and call css  */
.modal-body {
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-icon {
  width: 150px;
  height: 150px;
  margin: 0 auto 12px;
  background-color: #00bdff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.calling-badge {
  font-size: 12px;
  padding: 4px 10px;
  background-color: #0a3e5b;
}
.dial-widget {
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.dial-widget li {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dial-widget li:first-child {
  background-color: #6695b2;
}
.dial-widget li:nth-child(2) {
  font-size: 18px;
  background-color: #6695b2;
}
.dial-widget li:nth-child(3) {
  background-color: #1a9bf8;
}
.dial-widget li:nth-child(4) {
  background-color: #1a9bf8;
}
.dial-widget li:nth-child(3) .fa-pause {
  position: absolute;
  top: 11px;
  right: 14px;
}
.dial-widget li:nth-child(3) .fa-phone,
.dial-widget li:nth-child(4) .fa-phone {
  font-size: 18px;
  margin-right: 4px;
}
.dial-widget li:nth-child(4) .fa-right-long {
  position: absolute;
  top: 13px;
  right: 8px;
}
.dial-widget li:nth-child(5) {
  font-size: 18px;
  background-color: #ff3600;
  transform: rotate(134deg);
}
.bg-lightblack {
  width: 475px;
  height: 475px;
  background-color: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancel-btn {
  color: #fff;
  border-radius: 0px;
  background-color: #000;
}
.close-btn {
  color: #fff;
  border-radius: 0px;
  background-color: #ff3600;
}
.close-btn i {
  transform: rotate(133deg);
}
.close-btn span {
  margin-left: 12px;
}
.mw-20 {
  max-width: 20px;
}
.outline-0 {
  outline: 0px;
}

/* incoming call css */
.incoming-call {
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.incoming-end-call {
  transform: rotate(136deg);
  background-color: #f43631;
}
.incoming-end-call i {
  font-size: 30px;
}
.incoming-call-receive {
  background-color: #40c689;
  animation: play 1.5s ease infinite;
  backface-visibility: hidden;
}
.incoming-call-receive i {
  font-size: 30px;
}
.incoming-end-call:before {
  position: absolute;
  content: " ";
  z-index: -1;
  top: -15px;
  left: -15px;
  background-color: #f43631;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  animation-fill-mode: both;
  opacity: 0.6;
  animation: incomingPulse 1.5s ease-out;
  animation-iteration-count: infinite;
}

@keyframes incomingPulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  25% {
    transform: scale(0.3);
    opacity: 1;
  }
  50% {
    transform: scale(0.6);
    opacity: 0.6;
  }
  75% {
    transform: scale(0.9);
    opacity: 0.3;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes play {
  0% {
    transform: scale(1);
  }
  15% {
    box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.4);
  }
  25% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.4),
      0 0 0 20px rgba(255, 255, 255, 0.2);
  }
  25% {
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0.4),
      0 0 0 30px rgba(255, 255, 255, 0.2);
  }
}
.pt-30 {
  padding-top: 40px;
}
.edit-icon i {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.min-h-357 {
  min-height: 357px;
}
</style>
